import type { Theme } from '@mui/material';

import type { HistoricalData, KpiLabels } from 'src/types/dashboard';

export const getBarColorMap = (theme: Theme): [string, string][] => [
  [theme.colors.secondary[400], theme.colors.secondary[900]],
  [theme.colors.primary[400], theme.colors.secondary[900]],
  [theme.colors.neutral[400], theme.colors.secondary[800]],
];

export const kpiReducer = (kpiList: KpiLabels, filterList?: string[]) => {
  if (!filterList || !filterList.length) return kpiList;
  return filterList.reduce(
    (acc, kpiKey) =>
      kpiList[kpiKey] ? { ...acc, [kpiKey]: kpiList[kpiKey] } : acc,
    {},
  );
};

export const getGroupData = (
  historicalData: HistoricalData,
  groupSelection: string[],
  kpiList: KpiLabels,
): [string, [number, string][], boolean][] =>
  Object.entries(historicalData).map(([label, values], i, source) => [
    label, // label of the x-axis
    groupSelection.map((kpi) => [values[kpi], kpiList[kpi]]), // array of data + name
    source.length === i + 1, // indicator for the latest item
  ]);
